export default __webpack_public_path__ + "static/media/results1.a9d40824.png";